import { TablePaginationConfig } from 'antd';
import type { ReadingGroupFilter } from 'services/api/inventoryMeterReadingGroups';

export const DEFAULT_FILTER: ReadingGroupFilter = {
  id: undefined,
  name: undefined,
  sortOrder: 'ascend',
  sortField: 'id',
};

export type ReadingGroupListPagination = Required<Pick<TablePaginationConfig, 'pageSize' | 'current' | 'total'>>;

export const DEFAULT_PAGINATION = {
  current: 1,
  pageSize: 10,
  total: 0,
};
